import React, { Fragment } from "react";
import { MessageText } from 'ts-types/api.types';
import _ from 'lodash';

export const applyStyles = (text: string) => {

  const regex = /\*\*\$\*(.+?)\*\$\*\*|\*\*\*(.+?)\*\*\*|\[\[nl]]/g;
  let match = regex.exec(text);

  let prevMatchEnd = 0;
  let textNodes = [];
  let ix = 0;
  while (match) {
    if (match[0].startsWith("**$*")) {
      textNodes.push(<Fragment key={ix++}>{text.substring(prevMatchEnd, match.index)}</Fragment>);
      textNodes.push(<span key={ix++} className="highlight-value">{match[1]}</span>);
      prevMatchEnd = match.index! + match[0].length;
    } else if (match[0].startsWith("***")) {
      textNodes.push(<Fragment key={ix++}>{text.substring(prevMatchEnd, match.index)}</Fragment>);
      textNodes.push(<b key={ix++}>{match[2]}</b>);
      prevMatchEnd = match.index! + match[0].length;
    } else if (match[0] === "[[nl]]") {
      textNodes.push(<Fragment key={ix++}>{text.substring(prevMatchEnd, match.index)}</Fragment>);
      textNodes.push(<br key={ix++}/>);
      prevMatchEnd = match.index! + match[0].length;
    }

    match = regex.exec(text);
  }

  if (prevMatchEnd !== text.length) {
    textNodes.push(<Fragment key={ix++}>{text.substring(prevMatchEnd, text.length)}</Fragment>);
  }

  return <>{textNodes}</>;
};

export const getText = (text: MessageText, lang: string): string => {
  // @ts-ignore
  const langText = text[`text${_.capitalize(lang)}`];
  if (langText) {
    return langText;
  }
  return text.textDe;
}
